import { createRoot } from "react-dom/client";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { App } from "./App";

console.log("=== OLI Word Starting ===");

const container = document.getElementById("root");

if (container) {
  const root = createRoot(container);

  const renderApp = () => {
    console.log("Rendering App...");
    root.render(
      <FluentProvider theme={webLightTheme}>
        <App />
      </FluentProvider>
    );
  };

  // Wait for Office.js to be ready before rendering
  if (typeof Office !== "undefined") {
    console.log("Office.js detected, waiting for onReady...");
    Office.onReady((info) => {
      console.log("Office.onReady:", info.host, info.platform);
      renderApp();
    });
  } else {
    console.log("No Office.js, rendering immediately");
    renderApp();
  }
} else {
  console.error("Container #root not found!");
}
